import { ReactNode } from 'react'
import { isBlurValue } from './is'
import { isNumber } from 'lodash'

function formatNumber(value: number): [formatValue: number | string, unit: string] {
  if (value / 1000 / 1000 / 1000 >= 1) {
    return [(value / 1000 / 1000 / 1000).toFixed(1), 'B']
  } else if (value / 1000 / 1000 >= 1) {
    return [(value / 1000 / 1000).toFixed(1), 'M']
  } else if (value / 1000 >= 1) {
    return [(value / 1000).toFixed(1), 'K']
  } else {
    // 没有小数位，直接返回
    if (value === Number(value.toFixed(0))) {
      return [value, '']
    }

    return [value.toFixed(1), '']
  }
}

export function formatDigital(value) {
  if (!value) return [value, '']
  if (typeof value === 'number') {
    return formatNumber(value)
  } else {
    return [value, '']
  }
}

export function formatLocaleString(num) {
  return (+num || 0).toLocaleString()
}

// 复制文本到剪贴板
export function copyText(text) {
  if (navigator?.clipboard) {
    navigator.clipboard.writeText?.(text)
  } else {
    // 创建输入框
    const textarea = document.createElement('textarea')
    document.body.appendChild(textarea)
    // 隐藏此输入框
    textarea.style.position = 'absolute'
    textarea.style.clip = 'rect(0 0 0 0)'
    // 赋值
    textarea.value = text
    // 选中
    textarea.select()
    // 复制
    document.execCommand('copy', true)
  }
}

export function addEnhancedConversion(email: string) {
  try {
    window.enhanced_conversion_data = { email }
    window.gtag('event', 'conversion', {
      send_to: 'AW-11015810512/kiupCKGh6oAYENDb34Qp',
      value: 1.0,
      currency: 'USD'
    })
  } catch (error) {
    console.log(error)
  }
}

// 拼接带有压缩参数和裁剪参数的图片url
export const getFillCoverUrl = (url: string, fillParams: string) => {
  if (!url) return ''
  if (isBlurValue(url)) {
    return url
  } else if (url.includes('?')) {
    const splitUrls = url.split('?')

    return `${splitUrls[0]}${fillParams}?${splitUrls[1]}`
  } else {
    return `${url}${fillParams}`
  }
}

export function splitStringByNewline(str: string) {
  const array: string[] = str.split(/[\r\n]+/)
  return array.filter((i) => i !== '')
}

export const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

export const emailFormValidator = (value: string | undefined, callback: (error?: ReactNode) => any) => {
  // 使用正则校验邮箱
  if (!value || !emailReg.test(value)) {
    callback(true)
  }
}

export const phoneReg = /^1\d{10}$/
export const phoneFormValidator = (value: string | undefined, callback: (error?: ReactNode) => any) => {
  // 使用正则校验手机号
  if (!value || !phoneReg.test(value)) {
    callback(true)
  }
}

// 上报注册成功百度营销事件
export function baiduRegisterEvent() {
  window._agl && window._agl.push(['track', ['success', { t: 3 }]])
}

export function formatNumberWithUnits(num: number): string {
  if (isNumber(num)) {
    if (num < 1000) {
      return `${num}`
    }

    const units = ['K', 'M', 'B']
    let unitIndex = -1
    let formattedNum = num

    while (formattedNum >= 1000 && unitIndex < units.length - 1) {
      formattedNum /= 1000
      unitIndex++
    }

    return `${formattedNum.toFixed(2)}${units[unitIndex]}`
  }
  return num
}
